import HRWorkActivityPage from "../components/hrWorkActivity/main";

const HRWorkActivity = () => {
  return <HRWorkActivityPage />;
};

export default HRWorkActivity;
